import axios from "axios";
import { generateTraceId } from "../../../helpers";
import { config } from "../../../../config/envs";

// monolito jusfy-backend (BulkQueriesHability vive aqui)
const apiUrl = config?.app?.baseUrl ?? "";
const adminBaseUrl = config?.app?.adminBaseUrl ?? "";

const traceHeaders = () => ({ headers: { "x-trace-id": generateTraceId() } });

// GET /bulk-queries-hability/:client_id  -> { enabled }
export async function getBulkQueries({ clientId }) {
  const res = await axios.get(
    `${apiUrl}/bulk-queries-hability/${clientId}`,
    traceHeaders(),
  );
  return res.data;
}

// POST /admin/bulk-queries-hability/:client_id  { enabled }  -> { message, data: { enabled } }
export async function toggleBulkQueries({ clientId, enabled }) {
  const res = await axios.post(
    `${adminBaseUrl}/bulk-queries-hability/${clientId}`,
    { enabled },
    traceHeaders(),
  );
  return res.data?.data ?? res.data;
}
